module.exports = __webpack_public_path__ + "img/kdIcon1.37dd722d.png";